module.exports = __webpack_public_path__ + "static/media/Madison.669dcbdf.jpg";